import React from "react";
import { withTheme } from "styled-components";
import { FormattedMessage } from "@irati/utils/lang";
import { H3, Label } from "@irati/ui/src/Typography";
import { StyledFlex } from "./styled";
var BoostedAmount = function (_a) {
    var value = _a.value, theme = _a.theme;
    return (React.createElement(StyledFlex, { direction: "column", padding: theme.spacing.one + " " + theme.spacing.oneAndHalf, margin: "0px " + theme.spacing.one + " 0px 0px" },
        React.createElement(Label, { small: true, color: "" + theme.colors.primary2, textAlign: "center" },
            React.createElement(FormattedMessage, { id: "perks.deals.boostedSaving.boostedAmount.text" })),
        React.createElement(H3, { color: "" + theme.colors.primary2, textAlign: "center" }, value + "%")));
};
export default withTheme(BoostedAmount);
